<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      errorMessage: errorMessage$ | async,
      errorMessageFrom: errorMessageFrom$ | async,
      errorMessageTo: errorMessageTo$ | async,
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner" [formGroup]="questionForm">
      <lib-input-container
        [headLine]="
          question.translations?.list['headLine']
            | translate: data.activeLang : question.structure.headLine
        "
        [description]="
          question.translations?.list['description']
            | translate: data.activeLang : question.structure.description
        "
        [labelPrefix]="questionNumber$ | async"
        [label]="
          question.translations?.list['title']
            | translate: data.activeLang : question.title
        "
        [questionMarkText]="
          question.translations?.list['questionMarkText']
            | translate: data.activeLang : question.structure.questionMarkText
        "
        [required]="
          question.structure.interval ? true : question.validation.required
        "
        [errorText]="
          question.structure.interval ? undefined : data.errorMessage
        "
        [for]="labelPrefix + question.id"
        [inputType]="InputType.Date"
        [width]="question.structure.interval ? 'full' : 'medium'"
        [hideBelow]="question.structure.interval"
        [helpText]="
          question.translations?.list['helpText']
            | translate: data.activeLang : question.structure.helpText
        "
      >
        @if (!question.structure.interval) {
          @if (!data.readOnly) {
            <lib-dot-indicator
              type="datepicker"
              [isVisible]="
                showChanges() &&
                previousAnswersService.hasDateValueChanged(
                  question.id,
                  repeaterGroupId,
                  value?.value
                )
              "
            />
            <lib-datepicker
              [minDate]="minDate"
              [maxDate]="maxDate"
              [isInvalid]="data.errorMessage"
              [formControl]="value"
              [id]="labelPrefix + question.id"
              [label]="
                question.translations?.list['title']
                  | translate: data.activeLang : question.title
              "
            ></lib-datepicker>
          }
          @if (data.readOnly) {
            <ng-container
              *ngTemplateOutlet="
                readonlyTemplate;
                context: {
                  date: toDateReadonly(),
                }
              "
            ></ng-container>
          }
        }
        @if (question.structure.interval) {
          <div class="d-md-flex justify-content-between">
            <lib-input-container
              [label]="
                question.translations?.list['startDateTitle']
                  | translate
                    : data.activeLang
                    : question.structure.startDateTitle
              "
              [required]="question.validation.required"
              [errorText]="data.errorMessageFrom"
              [for]="labelPrefix + question.id + '_1'"
              [inputType]="InputType.Date"
              width="full"
              class="w-100"
              [helpText]="
                question.translations?.list['helpText']
                  | translate: data.activeLang : question.structure.helpText
              "
            >
              @if (!data.readOnly) {
                <lib-dot-indicator
                  type="datepicker"
                  [isVisible]="
                    showChanges() &&
                    previousAnswersService.hasDateRangeFieldChanged(
                      question.id,
                      repeaterGroupId,
                      'fromDate',
                      fromDate?.value
                    )
                  "
                />
                <lib-datepicker
                  [formControl]="fromDate"
                  [ansokanCreatedDate]="ansokanCreatedDate"
                  [id]="labelPrefix + question.id + '_1'"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [maxLength]="
                    question.key === StructuredDataKey.Projekttid
                      ? 5
                      : undefined
                  "
                  [isInvalid]="!!data.errorMessageFrom"
                  [isStartDate]="true"
                  [label]="
                    question.translations?.list['startDateTitle']
                      | translate
                        : data.activeLang
                        : question.structure.startDateTitle
                  "
                ></lib-datepicker>
              }
              @if (data.readOnly) {
                <ng-container
                  *ngTemplateOutlet="
                    readonlyTemplate;
                    context: {
                      date: fromDateReadonly(),
                    }
                  "
                ></ng-container>
              }
            </lib-input-container>
            <lib-input-container
              [label]="
                question.translations?.list['endDateTitle']
                  | translate: data.activeLang : question.structure.endDateTitle
              "
              [required]="question.validation.required"
              [errorText]="data.errorMessageTo"
              [for]="labelPrefix + question.id + '_2'"
              [inputType]="InputType.Date"
              width="full"
              class="w-100 ms-4"
            >
              @if (!data.readOnly) {
                <lib-dot-indicator
                  type="datepicker"
                  [isVisible]="
                    showChanges() &&
                    previousAnswersService.hasDateRangeFieldChanged(
                      question.id,
                      repeaterGroupId,
                      'toDate',
                      toDate?.value
                    )
                  "
                />
                <lib-datepicker
                  [formControl]="toDate"
                  [id]="labelPrefix + question.id + '_2'"
                  [minDate]="minEndDate"
                  [maxDate]="maxEndDate"
                  [maxLength]="
                    question.key === StructuredDataKey.Projekttid
                      ? 5
                      : undefined
                  "
                  [isInvalid]="!!data.errorMessageTo"
                  [isStartDate]="false"
                  [maxDateIsFromFormSettings]="maxDateIsFromFormSettings"
                  [label]="
                    question.translations?.list['endDateTitle']
                      | translate
                        : data.activeLang
                        : question.structure.endDateTitle
                  "
                ></lib-datepicker>
              }
              @if (data.readOnly) {
                <ng-container
                  *ngTemplateOutlet="
                    readonlyTemplate;
                    context: {
                      date: toDateReadonly(),
                    }
                  "
                ></ng-container>
              }
            </lib-input-container>
          </div>
        }
      </lib-input-container>
      <ng-template #readonlyTemplate let-date="date">
        <div
          class="readonly"
          [ngClass]="
            data.errorMessage || data.errorMessageFrom || data.errorMessageTo
              ? 'invalid'
              : ''
          "
        >
          {{ date }}
          <div class="icon-btn open-calendar-btn" [aria-hidden]="true">
            <lib-icon name="calendar" size="small"></lib-icon>
          </div>
        </div>
      </ng-template>
    </div>
  }
</ng-container>
